import styled, { keyframes, css } from "styled-components";

const ChangeBtn = keyframes`
  /* 0.533s */
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.51, 0, 0.67, 0.84);
  }
  34% {
    transform: rotate(331.17deg);
    animation-timing-function: cubic-bezier(0.26, 2.68, 0.58, 1);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const currCardApear = keyframes`
  /* 0.500s */
  0% {
    transform: scale(0);
  }
  6% {
    transform: scale(0.5);
    animation-timing-function: linear;
  }
  40% {
    transform: scale(0.98);
    animation-timing-function: cubic-bezier(0.18, 0.05, 0.51, 0.95);
  }
  100% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.32, 1.63, 0.65, 1);
  }
`;
const currCardDisApear = keyframes`
  /* 0.500s */
  0% {
    transform: translateX(50%) rotate(0deg);
  }
  100% {
    transform: translateX(250%) rotate(-90deg);
    animation-timing-function: cubic-bezier(0,0,0.5,1);
  }
`;
const currCardApearAnim = css`
  ${currCardApear}
`;
const currCardDisApearAnim = css`
  ${currCardDisApear}
`;
const ChangeBtnAnim = css`
  ${ChangeBtn}
`;
export const CardsContainer = styled.div`
  /* padding: 18px; */
  /* margin: 18px auto; */
  padding: 40px;
  overflow-x: hidden;
  width: 100%;
  touch-action: manipulation;
  @media only screen and (min-width: 375px) {
    padding: 40px;
    /* margin: 40px auto; */
  }
`;
export const CardBox = styled.div`
  position: relative;
  width: 100%;
`;

export const BackCard = styled.div`
  height: 295px;
  width: 192px;
  background: #e7e2de;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.4);
  position: absolute;
  border-radius: 22px;
  transition: all 0.5s;
  right: 50%;
  z-index: 1;
`;

export const RotatableCard = styled.div`
  height: 295px;
  width: 192px;
  position: absolute;
  top: 0;
  right: 50%;
  transform: translateX(50%) rotate(0deg);
  background: #e7e2de;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.4);
  border-radius: 22px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  animation: ${(p) => (p.cardChange ? currCardDisApearAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  /* animation-delay: 0.167s; */
`;
export const Card = styled.div`
  height: 295px;
  width: 192px;
  background: #e7e2de;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.4);
  border-radius: 22px;
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  animation: ${(p) => (p.cardChange ? currCardApearAnim : null)};
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  /* animation-delay: 0.167s; */
`;

export const CardSuit = styled.div`
  width: 102px;
  height: 83px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    width: 102px;
    height: 83px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  /* color: ${(props) => (props.red ? "#db4646" : "#483b3b")}; */
`;

export const CardSymbol = styled.div`
  font-size: 100px;
  color: ${(props) => (props.color === "red" ? "#db4646" : "#483b3b")};
`;

export const RandomBtn = styled.div`
  position: absolute;
  cursor: pointer;
  top: 20px;
  left: 15px;
  z-index: 2;
  width: 30px;
  height: 21px;
  animation: ${(p) => (p.change ? ChangeBtnAnim : null)};
  animation-duration: 0.533s;
  animation-fill-mode: forwards;
  /* pointer-events: ${(p) => (p.disabled ? "none" : "auto")}; */
  touch-action: manipulation;
`;
